import React from "react";
import { Link } from "react-router-dom";
import { SECTORS } from "../lib/sectors";
import { WHATSAPP_ORDER_URL } from "./Nav";

// Show a subset in the footer; the /areas hub links the rest.
const FOOTER_AREAS = [
  "sector-14", "sector-43", "sector-56",
  "dlf-phase-1", "dlf-phase-3",
  "sushant-lok", "golf-course-road", "sohna-road",
];

export default function Footer() {
  const shown = FOOTER_AREAS
    .map((slug) => SECTORS.find((s) => s.slug === slug))
    .filter(Boolean);
  return (
    <footer className="mt-24 border-t border-rw-ink/10 bg-rw-bg3" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-5 gap-10">
        <div className="md:col-span-2">
          <img src="/logos/brand-logo.png" alt="RIZ N WASH" className="h-10 w-auto" />
          <p className="mt-3 text-rw-ink2 max-w-md">
            Premium doorstep laundry &amp; dry cleaning across Gurugram. Hygienic, on-time, and folded with care.
          </p>
          <div className="mt-6 text-sm text-rw-ink2">
            <div><span className="overline mr-2">Call</span>+91 73032 41330</div>
            <div className="mt-1"><span className="overline mr-2">Hours</span>Open 24 hours · 7 days a week</div>
            <div className="mt-1"><span className="overline mr-2">Area</span>Gurugram, Delhi NCR</div>
          </div>
          <div className="mt-5 flex items-center gap-3" data-testid="footer-socials">
            <a
              href="https://www.instagram.com/riznwash/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="RIZ N WASH on Instagram"
              className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-rw-ink/15 text-rw-ink2 hover:text-white hover:bg-rw-ink hover:border-rw-ink transition-colors"
              data-testid="footer-instagram"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
              </svg>
            </a>
            <a
              href="https://wa.me/917303241330"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="RIZ N WASH on WhatsApp"
              className="inline-flex items-center justify-center h-9 px-3 rounded-full border border-rw-ink/15 text-xs font-semibold text-rw-ink2 hover:text-white hover:bg-rw-ink hover:border-rw-ink transition-colors"
              data-testid="footer-whatsapp"
            >
              WhatsApp
            </a>
          </div>
        </div>
        <div>
          <div className="overline mb-3">Services</div>
          <ul className="space-y-2 text-sm" data-testid="footer-services">
            <li><Link to="/services/wash-and-fold-gurugram" className="hover:text-rw-ink text-rw-ink2" data-testid="footer-svc-wash">Wash &amp; fold</Link></li>
            <li><Link to="/services/dry-cleaning-gurugram" className="hover:text-rw-ink text-rw-ink2" data-testid="footer-svc-dry">Dry cleaning</Link></li>
            <li><Link to="/services/shoe-cleaning-gurugram" className="hover:text-rw-ink text-rw-ink2" data-testid="footer-svc-shoe">Shoe &amp; sneaker care</Link></li>
            <li><Link to="/services/curtain-carpet-cleaning-gurugram" className="hover:text-rw-ink text-rw-ink2" data-testid="footer-svc-curtain">Curtains &amp; carpets</Link></li>
            <li><Link to="/services/bedsheet-duvet-cleaning-gurugram" className="hover:text-rw-ink text-rw-ink2" data-testid="footer-svc-duvet">Duvets &amp; bedsheets</Link></li>
            <li>
              <Link to="/best-laundry-gurugram" className="hover:text-rw-ink text-rw-ink font-semibold" data-testid="footer-best-laundry">
                Best laundry in Gurugram →
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">Service areas</div>
          <ul className="space-y-2 text-sm" data-testid="footer-areas">
            {shown.map((s) => (
              <li key={s.slug}>
                <Link to={`/laundry/${s.slug}`} className="hover:text-rw-ink text-rw-ink2" data-testid={`footer-area-${s.slug}`}>
                  Laundry in {s.name}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/areas" className="hover:text-rw-ink text-rw-ink font-semibold" data-testid="footer-all-areas">
                All areas →
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/guides" className="hover:text-rw-ink text-rw-ink2" data-testid="footer-guides">Care guides</Link></li>
            <li><Link to="/same-day-laundry-gurugram" className="hover:text-rw-ink text-rw-ink2" data-testid="footer-same-day">Same-day laundry</Link></li>
            <li><Link to="/track" className="hover:text-rw-ink text-rw-ink2">Track order</Link></li>
            <li><Link to="/plans" className="hover:text-rw-ink text-rw-ink2">Weekly plans</Link></li>
            <li>
              <a href={WHATSAPP_ORDER_URL} target="_blank" rel="noopener noreferrer" className="btn-dark inline-flex mt-2 rounded-full px-4 py-2 text-xs font-semibold" data-testid="footer-book-btn">
                Order on WhatsApp →
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-rw-ink/10 py-6 flex flex-wrap items-center justify-between gap-3 px-6 md:px-10 max-w-7xl mx-auto text-xs text-rw-ink3">
        <span>© {new Date().getFullYear()} RIZ N WASH · Made with love in Gurugram</span>
        <div className="flex items-center gap-4">
          <Link to="/rider" className="hover:text-rw-ink" data-testid="footer-rider-link">
            Rider portal
          </Link>
          <Link to="/admin" className="hover:text-rw-ink" data-testid="footer-admin-link">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
